<!-- 
  COMPONENT LegalNotice
-->


<!---------- SCRIPT ---------->

<script lang="ts" type="module">

	import { onMount } from "svelte";
	import { 
		deglingos,
		minitel,
		english, 
		activite,
		activity,
		brand,
		fullName,
		website,
	} from "../store/store";

	onMount(async () => {
		window.scrollTo(0, 0);
	})

</script>


<!---------- STYLE ---------->

<style lang="scss">

	.section {
		&__deglingos {
			border-radius: 15% 15% 15% 15%;
		}
	}

	.article {
		&__p {
			text-align: left;
		}
	}

	@include large {
		.section {
			padding: 0 16px 0 16px;
			align-items: flex-start;
			&__deglingos {
				margin: 0 32px 32px 32px;
			}
		}

		.article {
			width: 100%;
			&__deglingos {
				align-items: center;
			}
		}
	}
</style>


<!---------- TEMPLATE ---------->

<div class="pageContent">
	{#if $english}
		<h1 class="article__h1" class:article__minitel__h1={$minitel}>LEGAL NOTICE</h1>
		<section class="section" class:section__minitel={$minitel} 
				class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Identity</h1>
				<p class="article__p">
					{$brand} - {$fullName} - Freelance<br />
					SIRET 801 185 448 00025<br />
					APE : 6201Z IT Development<br />
					3, lotissement Redier 50590 Montmartin sur mer, FRANCE
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Conditions of access and use</h1>
				<p>
					This site is a presentation site, the purpose of which is to provide
					information on the activity of the {$activity} 
					{$brand}, represented by {$fullName}, designer and developer 
					freelance. This website is subject to French law. Using
					this site, you acknowledge having the skills and
					means necessary to access and use this site. You
					also acknowledge having read this
					legal notice and you agree to comply with it. You recognize
					moreover, having been informed that the site is accessible 24 hours a day
					24/7, except in cases of force majeure,
					IT difficulties, difficulties linked to
					telecommunications or other technical difficulties. For some
					maintenance reasons, {$brand} may interrupt access to the
					site and will endeavor to notify users in advance.
					{$brand} cannot be held responsible for the impossibility
					to access this site.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Information made available on the site</h1>
				<p>
					The information provided on this site is purely
					informative. {$brand} makes every effort to ensure the accuracy and
					up-to-date information, particularly financial, disseminated on this
					site, of which it reserves the right to modify and correct the
					content at any time without notice. However, it cannot
					guarantee the completeness, precision, exhaustiveness or
					no modification by a third party. {$brand} is available in
					consequence any liability: 
				</p>
				<ul>
					<li>
						in the event of imprecision, inaccuracy, error or omission
						relating to information available on the site;
					</li>
					<li>lack of availability of information;</li>
					<li>
						for all damages, direct and / or indirect, whatever
						be the causes, origins, nature or consequences,
						caused by anyone's access to the site or
						the inability to access it;					</li>
					<li>
						the use of the site and / or the credit granted to a
						any information coming directly or
						indirectly from the site;
					</li>
					<li>
						decisions made on the basis of information contained
						on the site, and the use that could be made of it
						by third parties.
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Hypertext links policy</h1>
				<p>
					The hypertext links set up within the framework of this site in
					management of other resources on the Internet,
					and in particular to partners, have been the subject of
					prior and express authorization. However, not being
					the publisher of these sites, we cannot control their content.
					Consequently, we can in no case be held for
					responsible for the content of the sites thus accessible, or
					any collection and transmission of personal data,
					installation of cookies or any other process tending to the same
					purposes, carried out by these sites. Thus, the existence of a link of
					{$brand} site to another site does not constitute
					recommendation or validation of this site or its content.
					It is up to the user to use this information with
					discernment and critical thinking. Users and visitors
					<i>{$website}</i> site cannot under any circumstances set up a
					hypertext link to the site without written permission
					and preliminary by {$fullName}. Any request to this end
					should be addressed to {$fullName}.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Computing and Freedom</h1>
				<p>
					The <i>{$website}</i> site is exempt from declaration to the
					National Commission for Informatics and Freedoms
					(CNIL-France) following the implementation of the General Regulations on
					Data Protection Act of 25 May 2018. In certain cases
					(questionnaires, request for information, etc.), {$brand} can be
					required to ask Internet users to communicate
					personal information such as their name, first name,
					contact details and email address. User is informed
					that he has a right of access, rectification and
					deletion of data concerning him by writing
					by mail to the address mentioned in paragraph
					"Identity". The user is notably informed that,
					in accordance with the amended law of 6 January 1978, the
					personal information communicated by the user due to
					forms on the site are intended only for
					{$brand}. The user has the right to oppose
					this communication by writing to the address mentioned in the
					paragraph "Identity".
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Intellectual property</h1>
				<p>
					All data (texts, sounds or images), and databases
					data, if any, appearing on the pages of this site are
					the exclusive property of {$brand}. Any reproduction,
					representation or distribution, in whole or in part, of the content as
					that any extraction, even partial, of the databases of this
					site on any medium or by any process whatsoever is
					prohibited. Failure to comply with this prohibition constitutes a
					counterfeiting liable to incur civil liability and
					criminal offense of the infringer.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Cookies</h1>
				<p>The <i>{$website}</i> site does not collect any cookies.</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Pricing</h1>
				<p>
					Access to the <i>{$website}</i> site is free, excluding connection costs
					depending on the Internet service provider.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Hosting</h1>
				<p>
					Hostinger International<br />
					61 Lordou Vironos, Larnaca, CY, 6023<br />
					Country : Chypre TVA: 10301365E<br />
					Phone: +357 22232364<br />
				</p>
			</article>
		</section>
	{:else}
		<h1 class="article__h1" class:article__minitel__h1={$minitel}>MENTIONS LÉGALES</h1>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Identité</h1>
				<p class="article__p">
					{$brand} - {$fullName} - Auto Entrepreneur<br />
					SIRET 801 185 448 00025<br />
					APE : 6201Z Programmation informatique<br />
					3, lotissement Redier 50590 Montmartin sur mer
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Conditions d'accès et d'utilisation</h1>
				<p>
					Ce site est un site de présentation, qui a pour objet de fournir
					des informations sur l'activité de l'{$activite}
					{$brand}, représentée par {$fullName}, concepteur et développeur
					freelance. Ce site est soumis à la loi française. En utilisant
					ce site, vous reconnaissez disposer de la compétence et des
					moyens nécessaires pour accéder à ce site et à l'utiliser. Vous
					reconnaissez également avoir pris connaissance de la présente
					notice légale et vous engagez à la respecter. Vous reconnaissez
					par ailleurs avoir été informé que le site est accessible 24 h
					sur 24 et 7 jours sur 7, sauf en cas de force majeure,
					difficultés informatiques, difficultés liées aux réseaux de
					télécommunications ou autres difficultés techniques. Pour des
					raisons de maintenance, {$brand} pourra interrompre l'accès au
					site et s'efforcera d'en avertir préalablement les utilisateurs.
					{$brand} ne saurait être tenu responsable de l'impossibilité
					d'accéder au présent site.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Informations mises à disposition sur le site</h1>
				<p>
					Les informations fournies sur ce site le sont à titre purement
					informatif. {$brand} s'efforce d'assurer l'exactitude et la mise
					à jour des informations, notamment financières, diffusées sur ce
					site, dont elle se réserve le droit de modifier et corriger le
					contenu à tout moment et sans préavis. Elle ne peut toutefois en
					garantir la complétude, la précision, l'exhaustivité ou
					l'absence de modification par un tiers. {$brand} décline en
					conséquence toute responsabilité :
				</p>
				<ul>
					<li>
						en cas d'imprécision, inexactitude, erreur ou omission
						portant sur des informations disponibles sur le site;
					</li>
					<li>d'une absence de disponibilité des informations;</li>
					<li>
						pour tous dommages, directs et/ou indirects, quelles qu'en
						soient les causes, origines, nature ou conséquences,
						provoqués à raison de l'accès de quiconque au site ou de
						l'impossibilité d'y accéder;
					</li>
					<li>
						de l'utilisation du site et/ou du crédit accordé à une
						quelconque information provenant directement ou
						indirectement du site;
					</li>
					<li>
						de décisions prises sur la base d'une information contenue
						sur le site, et de l'utilisation qui pourrait en être faite
						par des tiers.
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Politique de liens hypertextes</h1>
				<p>
					Les liens hypertextes mis en place dans le cadre de ce site en
					direction d'autres ressources présentes sur le réseau Internet,
					et notamment vers des partenaires, ont fait l'objet d'une
					autorisation préalable et expresse. Toutefois, n'étant pas
					l'éditeur de ces sites, nous ne pouvons en contrôler le contenu.
					En conséquence, nous ne pourrons en aucun cas être tenu pour
					responsable du contenu des sites ainsi accessibles, ou des
					éventuelles collectes et transmission de données personnelles,
					installation de cookies ou tout autre procédé tendant aux mêmes
					fins, effectués par ces sites. Ainsi, l'existence d'un lien du
					site de {$brand} vers un autre site ne constitue pas une
					recommandation, ni une validation de ce site ou de son contenu.
					Il appartient à l'utilisateur d'utiliser ces informations avec
					discernement et esprit critique. Les utilisateurs et visiteurs
					du site <i>{$website}</i> ne peuvent en aucun cas mettre en place un
					lien hypertexte en direction du site sans l'autorisation écrite
					et préalable de {$fullName}. Toute demande tendant à cette fin
					doit être adressée à {$fullName}.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Informatique et libertés</h1>
				<p>
					Le site <i>{$website}</i> est dispensé de déclaration auprès de la
					Commission nationale de l'informatique et des libertés
					(CNIL-France) suite à la mise en place du Règlement Général sur
					la Protection des Données du 25 mai 2018. Dans certains cas
					(questionnaires, demande d'information, etc.), {$brand} peut être
					amenée à demander aux internautes de lui communiquer des
					informations personnelles telles que leurs nom, prénom,
					coordonnées et adresse électronique. L'utilisateur est informé
					qu'il dispose d'un droit d'accès, de rectification et de
					suppression portant sur les données le concernant en écrivant
					par courrier à l'adresse mentionnée dans le paragraphe
					"Identité". L'utilisateur est notamment informé que,
					conformément à la loi du 6 janvier 1978 modifiée, les
					informations personnelles communiquées par l'utilisateur du fait
					des formulaires présents sur le site sont destinées uniquement à
					{$brand}. L'utilisateur dispose de la faculté de s'opposer à
					cette communication en écrivant à l'adresse mentionnée dans le
					paragraphe "Identité".
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Propriété intellectuelle</h1>
				<p>
					L'ensemble des données (textes, sons ou images), et bases de
					données le cas échéant, figurant sur les pages de ce site sont
					la propriété exclusive de {$brand}. Toute reproduction,
					représentation ou diffusion, en tout ou partie, du contenu ainsi
					que toute extraction, même partielle, des bases de données de ce
					site sur quelque support ou par tout procédé que ce soit est
					interdite. Le non-respect de cette interdiction constitue une
					contrefaçon susceptible d'engager la responsabilité civile et
					pénale du contrefacteur.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Cookies</h1>
				<p>Le site <i>{$website}</i> ne récolte aucun cookie.</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Tarification</h1>
				<p>
					L'accès au site <i>{$website}</i> est gratuit, hors coût de connexion
					selon le fournisseur d'accès Internet.
				</p>
			</article>
		</section>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<h1 class:article__minitel__h1={$minitel}>Hébergement</h1>
				<p>
					Hostinger International<br />
					61 Lordou Vironos, Larnaca, CY, 6023<br />
					Pays : Chypre TVA: 10301365E<br />
					Téléphone: +357 22232364<br />
				</p>
			</article>
		</section>
	{/if}
</div>